let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eiZZR")).then(() => parcelRequire('f8Y7f'));